<template>
	<div class="row followup-conversion-container">
		<div class="followup-conversion-title">Conversion Window</div>
		<div class="mt-xl-5 pt-xl-4">
			<template v-for="index in totalConversionsData">
				<div class="followup-conversion-item" :key="index">
					<div class="followup-conversion">Day
						<div class="day-count" v-if="index === 8">7+</div>
						<div class="day-count" v-else>{{ index }}</div>
					</div>
					<div class="followup-conversion-percentage">{{ data['conversions_data'][index]['percentage'] }}</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FollowUpConversion',
	props: {
		data: Object,
	},
	computed: {
		totalConversionsData() {
			return this.data.conversions_data ? Object.keys(this.data.conversions_data).length : 0;
		},
	},
};
</script>
